/**
 * 学习乐园 · 连连看题材包：国家首都（lianliankan/pack-shoudu.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：国家连首都（「法国」连「巴黎」）。note 存大洲——配上就
 * 知道「法国连巴黎——欧洲」，配对的同时把国家挂到洲架上（栏目
 * 「即时且可解释」口径；世界地理先建「洲—国—都」的骨架）。
 * 口径自检：每大洲选无争议的常考国（不收南非——三首都制、不收
 * 印度尼西亚——迁都过渡期，教材口径未稳）；每国唯一，牌面无重复。
 * 24 对备 18 对/局，每局组合不同。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.shoudu = {
    id: 'shoudu',
    name: '国家首都',
    hint: '国家连首都，顺手记大洲',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '中国', r: '北京', note: '亚洲' },
      { l: '日本', r: '东京', note: '亚洲' },
      { l: '韩国', r: '首尔', note: '亚洲' },
      { l: '泰国', r: '曼谷', note: '亚洲' },
      { l: '印度', r: '新德里', note: '亚洲' },
      { l: '越南', r: '河内', note: '亚洲' },
      { l: '蒙古', r: '乌兰巴托', note: '亚洲' },
      { l: '菲律宾', r: '马尼拉', note: '亚洲' },
      { l: '马来西亚', r: '吉隆坡', note: '亚洲' },
      { l: '埃及', r: '开罗', note: '非洲' },
      { l: '肯尼亚', r: '内罗毕', note: '非洲' },
      { l: '美国', r: '华盛顿', note: '北美洲' },
      { l: '加拿大', r: '渥太华', note: '北美洲' },
      { l: '墨西哥', r: '墨西哥城', note: '北美洲' },
      { l: '巴西', r: '巴西利亚', note: '南美洲' },
      { l: '阿根廷', r: '布宜诺斯艾利斯', note: '南美洲' },
      { l: '英国', r: '伦敦', note: '欧洲' },
      { l: '法国', r: '巴黎', note: '欧洲' },
      { l: '德国', r: '柏林', note: '欧洲' },
      { l: '意大利', r: '罗马', note: '欧洲' },
      { l: '俄罗斯', r: '莫斯科', note: '欧洲' },
      { l: '西班牙', r: '马德里', note: '欧洲' },
      { l: '澳大利亚', r: '堪培拉', note: '大洋洲' },
      { l: '新西兰', r: '惠灵顿', note: '大洋洲' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
